<template>
	<div>
		<v-container fluid grid-list-md>
			<v-layout row wrap>
			  <v-flex xs12>
			    <v-card>
			    <v-form
                id="create_visitor"
                @submit.prevent="createVisitor"
                data-vv-scope="createVisitor"
                ref="visitor_form"
                v-model="valid">
	                <v-card-text>
	                  <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
	                  	<v-layout row wrap>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="First Name"
	                        label="First Name"
	                        id="id"
	                        v-model="visitor_object.first_name"
	                        
	                    	></v-text-field>
	                  	  </v-flex>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="Last Name"
	                        label="Last Name"
	                        id="id"
	                        v-model="visitor_object.last_name"
	                    	></v-text-field>
	                  	  </v-flex>
	                  	</v-layout>
	                  	<v-layout row wrap>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="Mobile"
	                        label="Mobile"
	                        id="id"
	                        v-model="visitor_object.mobile"
	                    	></v-text-field>
	                  	  </v-flex>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="Email"
	                        label="Email"
	                        id="id"
	                        v-model="visitor_object.email"
	                    	></v-text-field>
	                  	  </v-flex>
	                  	</v-layout>
	                  </v-container>
	                </v-card-text>
	                <v-card-actions>
	              	<v-spacer></v-spacer>
	              		<v-btn color="primary" small :disabled="!valid" type="submit">Create</v-btn>
	              		<v-btn text small to="/visitors">Cancel</v-btn>
	          		</v-card-actions>
          		</v-form>
			    </v-card>
			  </v-flex>
			</v-layout>
		</v-container>	
	</div>
</template>
<script>
  export default {
  	methods:{
		validateBeforeSubmit: function(scope) {  
		      this.$validator.validateAll(scope).then(result => {
		        if (result) {
		          this[scope]();
		        }
		     });
    		},
    	createVisitor:function(){
    		
    		let new_visitor  = Object.assign({},this.visitor_object);
    		axios.post(`${process.env.VUE_APP_API_URL}/api/visitors`, new_visitor).then((response)=>{
    			if(response.data.status == 1)
				{	  
			      this.$router.push({ name: 'visitorDetails', params: {id: response.data.visitor.id}});
			      this.submit_loader=false;    
				}
				}).catch((error)=>{
				  console.log(error);
				}).finally(()=>{

				});	
    	}
    },
    data:()=>{
      return {
        visitor_object:{
        	first_name:'',
        	last_name:'',
        	mobile:'',
        	email:''
        },
        valid:false,
      }
    },
  };
</script>